import React, { useContext, useEffect, useState } from "react";
import { getBezierPath } from "reactflow";
import FlowContext from "../../../contexts/flowContext";
import SidebarContext from "../../../contexts/sidebar";
import styles from "./conditionalEdge.module.css";

const ConditionalEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  style = {},
  markerEnd,
  label,
}) => {
  const [flowState, flowDispatcher] = useContext(FlowContext);
  const [, dispatchSidebar] = useContext(SidebarContext);

  const [previousConditionLabels, setPreviousConditionLabels] = useState([]);
  const [foreignObjectSize, setForeignObjectSize] = useState(0);

  const [edgePath, edgeCenterX, edgeCenterY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  useEffect(() => {
    const edge = flowState.edges.filter((edge) => edge.id === id)[0];
    if (edge) {
      const node = flowState.nodes.filter((node) => node.id === edge.source)[0];

      let previousEdgeConditions = [];

      if (node && node.nextNodeListConditions) {
        const index = node.nextNodeListConditions.indexOf(id);
        if (index >= 0) {
          node.nextNodeListConditions.slice(0, index).forEach((edgeId) => {
            previousEdgeConditions.push(
              flowState.edges.filter((edge) => edge.id === edgeId)[0]
            );
          });
          setPreviousConditionLabels(
            previousEdgeConditions.map((edge) => {
              return edge ? edge.label : null;
            })
          );
        }
        //const previousConditions = node.nextNodeListConditions.
      }
    }
  }, [flowState.nodes, flowState.edges]);

  useEffect(() => {
    const letterWidth = 10;
    if (!previousConditionLabels.length) {
      setForeignObjectSize(label.length * letterWidth || 0.1);
    } else {
      let biggestLabel = label;
      previousConditionLabels.forEach((previousLabel) => {
        if (previousLabel && previousLabel.length > biggestLabel.length) {
          biggestLabel = previousLabel;
        }
      });
      setForeignObjectSize(biggestLabel.length * letterWidth || 0.1);
    }
  }, [previousConditionLabels]);

  const handleEdgeClick = function () {
    dispatchSidebar({
      type: "open",
      value: true,
      manager: "edge",
    });
    flowDispatcher({
      type: "unselect-all-nodes",
    });
    flowDispatcher({
      type: "set-selected-edge",
      id,
    });
  };

  return (
    foreignObjectSize && (
      <>
        <path
          id={id}
          style={style}
          className={styles.react_flow_edge_path}
          d={edgePath}
          markerEnd={markerEnd}
        />
        <foreignObject
          width={foreignObjectSize}
          height={30 + previousConditionLabels.length * 30}
          x={edgeCenterX - foreignObjectSize / 2}
          y={
            edgeCenterY -
            20 *
              (previousConditionLabels.length > 0
                ? previousConditionLabels.length
                : 1)
          }
          className={styles.edge_button_foreign_object}
          requiredExtensions="http://www.w3.org/1999/xhtml"
        >
          <div>
            <div className={styles.edge_button}>
              {previousConditionLabels.map((label, index) => (
                <span
                  className={styles.sp}
                  key={index}
                  onDoubleClick={handleEdgeClick}
                >
                  {label}
                </span>
              ))}
              <span
                className={styles.condition}
                onDoubleClick={handleEdgeClick}
              >
                {label}
              </span>
            </div>
          </div>
        </foreignObject>
      </>
    )
  );
};

export default ConditionalEdge;
